<template> 
  <v-card v-if="selectedUser" flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins zindex-1">  
      <v-row class="pb-6 mx-3">
        <v-col cols="2" md="1" class="d-none d-sm-flex justify-start">
          <div class="circle-with-text d-none d-sm-flex">{{ selectedUser | initials }}</div>
        </v-col>
        <v-col cols="7" md="7">
          <div class="title-icon">
            <div class="d-flex">
              <h4>{{ selectedUser | fullName }}</h4>
            </div>
          </div>
          <h6 class="mt-n4">{{selectedUser.userrole ? selectedUser.userrole.name :''}}</h6>
        </v-col>
        <!--  <v-col class="text-right">
            <v-btn disabled class="hidden-md-and-down">
              <v-icon>$sl-email</v-icon>Skicka meddelande
            </v-btn>
        </v-col>-->
      </v-row>
    </v-card>
    <v-card flat class="container--fluid">
        <v-tabs v-model="tab" :show-arrows="$vuetify.breakpoint.smAndDown">
          <v-tab key="1">
            <span class="hidden-md-and-down">Uppgifter</span>
            <span class="hidden-lg-and-up">Uppg.</span>
          </v-tab>
          <v-tab key="2">
            <span class="hidden-md-and-down">Notifieringar & Meddelanden</span>
            <span class="hidden-lg-and-up">Noti.</span>
          </v-tab>
          <v-tab key="3">
            <span class="hidden-md-and-down">Inloggning</span>
            <span class="hidden-lg-and-up">Inlo.</span>
          </v-tab>
          <v-tab key="4">
            <span class="hidden-md-and-down">Behörigheter</span>
            <span class="hidden-lg-and-up">Behö.</span>
          </v-tab>
          <!--   <v-tab key="5">Administrera</v-tab>
          <v-tab key="6">Aktivitetslogg</v-tab>-->

          <v-tab-item key="1" class="mx-6 mt-8">   
            <user-information
              ref="userInfoForm"
              :canSave="canSave"
              :canDelete="canDelete"
              :userRoles="userRoles"
              @saveuser="saveUser"
            />            
          </v-tab-item>
          <v-tab-item key="2" class="mx-6 mt-8">               
                <UserNotifications @saveuser="saveUser" ref="userNotificationForm" />              
          </v-tab-item>
          <v-tab-item key="3" class="mx-6 mt-8">                           
            <UserLogin @saveuser="saveUser" ref="userLoginForm" />              
          </v-tab-item>
          <v-tab-item key="4" class="mx-6 mt-8">    
              <UserCompetence
                  ref="userCompetenceForm"
                  :canSave="canSave"
                  :canDelete="canDelete"
                  :userRoles="userRoles"
                  @saveuser="saveUser"
                />              
          </v-tab-item>
        </v-tabs>
    </v-card>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api.js'
import UserInformation from '@/components/user/UserInformation'
import UserNotifications from '@/components/user/UserNotifications'
import UserLogin from '@/components/user/UserLogin'
import UserCompetence from '@/components/user/UserCompetence'
import UserSettings from '@/components/user/UserSettings'
import UserActivity from '@/components/user/UserActivity'
import {CompanyRoles} from '@/components/mixins'
// @group Person
// User component
export default {
  name: 'User',
  mixins: [CompanyRoles],
  data() {
    return {
      tab: null,
      editing: true,
      userRoles: [],
      canDelete: false,
      canSave: false
    }
  },

  components: {
    UserInformation,
    UserNotifications,
    UserLogin,
    UserCompetence,
    UserSettings,
    UserActivity
  },

  computed: {
    ...mapGetters('user', ['selectedUser']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserObj'])
    // @vuese
    // used to return full name
  },

  mounted() {
    console.log('User - mounted')
    this.fetchData()
    this.fetchSelects()
  },

  watch: {
    $route: 'fetchData'
  },

  methods: {
    ...mapActions('user', ['setSelectedUser']),
    // @vuese
    // Enables or disables buttons beased on policy
    async setAuth(userId) {
      //- C(r)UD
      if (userId) {
        // Updating
        await this.currentUserObj.can('user', 'delete').then(res => {
          if (userId === this.currentUser.id) {
            //- Special case, user can't delete him/herself
            this.canDelete = false
            return
          }
          this.canDelete = res
        })
        if (userId === this.currentUser.id) {
          this.canSave = true
        } else {
          await this.currentUserObj.can('user', 'update').then(res => {
            this.canSave = res
          })
        }
      } else {
        // Creating
        this.canDelete = false
        await this.currentUserObj.can('user', 'create').then(res => {
          this.canSave = res
        })
      }
    },
    /**
     * @vuese
     *  Used to fetch user or create a new one if the user exist
     */
    fetchData() {
      console.log('User - fetchData')
      // @vuese
      //- show user or create new one
      if (this.$route.params.id) {
        // @vuese
        //- Load user from database
        API.getUser(this.$route.params.id)
          .then(res => {
            // @vuese
            //- Add to local store selected user
            this.setAuth(res.data.id)
            this.setSelectedUser(res.data)
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      } else {
        console.log('User - fetchData - new user')
        // @vuese
        //- Set empty template
        this.setSelectedUser({
          firstName: '',
          lastName: '',
          email: null,
          personalNumber: null,
          address1: null,
          address2: null,
          zip: null,
          city: null,
          country: 'SE',
          mobilephone: null,
          loginByEmail: false,
          loginByBankId: false,
          userRoleId: 2,
          regionIds: [],
          allowMail: false,
          allowSMS: false,
          allowPush: false,
          allowApplicationNotifications: false,
          allowCompanyNotifications: false,
          allowTradeCertificateNotifications: false,
          allowMachineQualificationNotifications: false,
          allowDistanceOrderNotifications: false
        })

        this.setAuth(this.currentUser.id)
      }
    },
    /**
     * @vuese
     *  Used to list user roles
     */
    fetchSelects() {
      console.log('User - fetchSelects')

      API.listUserRoles()
        .then(response => {
          this.userRoles = response.data.rows.map(o => {
            const { id: value, name: text, role} = o;

            return {value, text, role}
          })
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    // @vuese
    // Saves the user
    saveUser() {
      //- Trigger validations and bug out on invalid
      if (
        !(this.$refs.userInfoForm&&this.$refs.userInfoForm.$refs.form.validate()) &&
        !(this.$refs.userLoginForm&&this.$refs.userLoginForm.$refs.form.validate()) &&
        !(this.$refs.userCompetenceForm&&this.$refs.userCompetenceForm.$refs.form.validate())
      ) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      // Add passwords when creating
      /*  if (this.selectedUser.loginByEmail && !this.selectedUser.id) {
        this.selectedUser.password = this.password
        this.selectedUser.passwordConfirmation = this.passwordConfirmation
      } */
     /*  if (!this.selectedUser.maskedPersonalnumber.includes('****'))
        this.selectedUser.personalNumber = this.selectedUser.maskedPersonalnumber
 */
      //- Update or Create
      API.setUser(this.selectedUser)
        .then(response => {
          if (!this.selectedUser.id) {
            // @vuese
            //- Update user in vuex store with created user
            this.setSelectedUser(response.data)
          }
          this.$events.fire('showInfo', 'Användaren sparad.')
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    // @vuese
    // Deletes user
    async deleteUser() {
      console.log('UserInformation - deleteUser')

      if (!(this.selectedUser && this.selectedUser.id)) {
        this.$events.fire('showError', 'Användaren är inte sparad ännu.')
        return
      }
      if (this.selectedUser.id === this.currentUser.id) {
        this.$events.fire('showError', 'Du kan inte radera dig själv.')
        return
      }

      const res = await this.$dialog.confirm({
        text: 'Radering av användare går inte att ångra.',
        title: 'Vill du verkligen radera denna användare?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) {
        return
      }

      API.deleteUser(this.selectedUser.id)
        .then(response => {
          this.$nextTick(
            () => this.$router.push({name: 'Users'}),
            this.$events.fire('showInfo', 'Användaren raderad.')
          )
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  }
}
</script>
